module.exports = __webpack_public_path__ + "img/切片-44.8592d852.jpeg";